import BaseSuggestor from './base-suggestor';

export default class GoogleMapsSuggestor extends BaseSuggestor {
    constructor(addressValidation = null) {
        super();
        this.attach = this.attach.bind(this);
        this.setAddress = this.setAddress.bind(this);
        this.addressValidation = addressValidation;
    }

    // Ignored because it's external API
    /* istanbul ignore next */
    attach(map) {
        const self = this;
        self.map = map;
        const input = document.getElementById('address');
        const autocomplete = new google.maps.places.Autocomplete(input, {
            componentRestrictions: { country: FPRE.country || 'de' },
            types: ['address'],
        });

        // Workaround to prevent submitting of the form when selecting a place from the list with Enter
        input.addEventListener('keydown', (event) => {
            if (event.keyCode === 13 && $('.pac-container:visible').length) {
                event.preventDefault();
            }
        });

        autocomplete.addListener('place_changed', () => {
            this.setAddress(autocomplete.getPlace());
        });

        if (self.map && input.value) {
            const displaySuggestions = function (predictions, status) {
                if (status != google.maps.places.PlacesServiceStatus.OK || !predictions) {
                    return;
                }

                if (predictions[0]) {
                    var request = {
                        placeId: predictions[0].place_id,
                        fields: ['geometry', 'address_components']
                    };
                    const placesService = new google.maps.places.PlacesService(self.map);
                    placesService.getDetails(request, (place, status) => {
                        if (status == google.maps.places.PlacesServiceStatus.OK) {
                            self.setAddress(place);
                        }
                    });
                };
            };

            const service = new google.maps.places.AutocompleteService();
            service.getPlacePredictions({ input: input.value }, displaySuggestions);
        }
    }


    setAddress(place) {
        if (!place || !place.address_components) return;

        const address = this.convertAddress(place);

        if (this.addressValidation && !this.addressValidation(address)) return;

        this.latitudeInput.val(address.latitude);
        this.longitudeInput.val(address.longitude);
        this.streetInput.val(address.route);
        this.houseNumberInput.val(address.street_number);
        this.zipInput.val(address.postal_code);
        this.cityInput.val(address.locality);

        this.addressInput.val(this.stripCountry(place.formatted_address, address.country));

        this.addressInputGroup.trigger('validate');
    }

    convertAddress(place) {
        const address = {};
        for (var field of place.address_components) {
            address[field.types[0]] = field.long_name;
            if (field.types[0] === 'country') {
                address.country_code = field.short_name;
            }
        }
        address.latitude = place.geometry.location.lat();
        address.longitude = place.geometry.location.lng();
        return address;
    }

    stripCountry(address, country) {
        if (!country || !address) return address;

        return address.replace(new RegExp(', ' + country + '$'), '');
    }
}
